import { s as script } from './Autocomplete-PtCdVo_0.js';
import { a as registerComponent } from './plugins-C7548x21.js';
import './helpers-O9h6_ICO.js';
import './typeof-Z4rCTFCZ.js';
import 'vue';
import './CompatFallthroughMixin-Ev2XGfi3.js';
import './config-nHWiBviw.js';
import './FormElementMixin-ILDlgM3i.js';
import './Input-0ivJhXUC.js';
import './Icon-fJqkx1gN.js';

var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, script);
  }
};

export { script as BAutocomplete, Plugin as default };
